import "./OrganisationUI.css";

import { Button, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  getAllAmniusAdmin,
  getAllSubscriptions,
  getOrganizationData,
} from "Config/API/get";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import AddAmniusAdmin from "Components/Popup/AddAmniusAdmin/AddAmniusAdmin";
import Headers from "Components/Header/Headers";
import HideSourceIcon from "@mui/icons-material/HideSource";
import IosShareIcon from "@mui/icons-material/IosShare";
import LanguageIcon from "@mui/icons-material/Language";
import Navigation from "Components/SideNavBar/Navigation";
import RenderAddUser from "Components/FileExplorer/AddUser/Container/RenderAddUser";
import RenderCard from "Components/Cards/ProfileCard/Container/RenderProfileCard";
import RenderSTInternalRaiseRequestForm from "Components/Popup/STRaiseInternalRequestForm/Container/RenderSTRaiseRequestForm";
import RenderSTRaiseRequestForm from "Components/Popup/STRaiseRequestForm/Container/RenderSTRaiseRequestForm";
import RequestPendingIcon from "Media/icons/req-pending.png";
import SendRequestIcon from "Media/icons/send-req.png";
import TabContent from "Components/TabContent/TabContent";
import UserManagementIcon from "Media/team-management (1)@2x.png";
import VerifiedIcon from "@mui/icons-material/Verified";
import { hashIdAction } from "Redux/action/variable.action";
import profilePic from "Media/blank-profile-picture.png";
import { renderOrganizationInfo } from "Redux/action/render.action";
import { requestConnection } from "Config/API/action";
import { toast } from "react-toastify";
import useFullPageLoader from "Hooks/useFullPageLoader";
import useIsAmniusOrganization from "Hooks/useIsAmniusOrganization";

const GREEN_BUTTON_STYLE = { background: "rgb(92, 161, 39) " };
const REQUEST_ICON_STYLE = { width: "26px" };

const isEmptyInfo = (info) =>
  info === undefined || info === null || info === "" || info?.length === 0;

const showFailureToast = () => toast("Failed! Try again later", { type: "error" });

const OrganisationUI = ({ general_info: generalInfoProp, role }) => {
  const [openAddUser, setOpenAddUser] = useState(false);
  const [openAddAmniusAdmin, setOpenAddAmniusAdmin] = useState(false);
  const [requestPopup, setRequestPopup] = useState(false);
  const [amniusAdmins, setAmniusAdmins] = useState([]);
  const [adminLoading, setAdminLoading] = useState(false);
  const [adminLoading2, setAdminLoading2] = useState(false);
  const [internalRequestPopup, setInternalRequestPopup] = useState(false);
  const [serviceTicketSubscription, setServiceTicketSubscription] = useState(
    []
  );
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [refreshuser, setRefreshuser] = useState(false);
  const [refreshcategory, setRefreshcategory] = useState(false);
  const token = localStorage.getItem("token");
  const isOrgAmnius = useIsAmniusOrganization();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const loggedInUser = useSelector((state) => state.authenticationReducer);
  const [loader, setLoader, resetLoader] = useFullPageLoader();

  const general_info = isEmptyInfo(generalInfoProp) ? {} : generalInfoProp;
  const isOtherRole = role?.toString() === "other";
  const isAmniusOrgPage = state?.data?.toString() === "1";
  // Amnius admin view: own org page as an Amnius admin, or the Amnius org opened from elsewhere
  const showAmniusAdmins = (isOrgAmnius && role !== "other") || isAmniusOrgPage;
  const requestButtonClass = isOtherRole ? "org-request-btn" : undefined;

  useEffect(() => {
    getAllAvailableSubscriptions();
    if (showAmniusAdmins) getAmniusAdmin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (state?.from === "navigation") return;
    getVisitedOrganizationData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const getAllAvailableSubscriptions = () => {
    setLoader();
    getAllSubscriptions(token).then((res) => {
      resetLoader();
      if (res?.data?.status) {
        const filteredSubscription = res.data.data?.filter(
          (item) => item?.subscription_type === "service_ticket"
        );
        setServiceTicketSubscription(filteredSubscription[0]);
      } else showFailureToast();
    });
  };

  const getVisitedOrganizationData = () => {
    setLoader();
    setAdminLoading2(true);
    getOrganizationData(token, state?.data)
      .then((res) => {
        setAdminLoading2(false);
        resetLoader();
        if (res?.status) dispatch(renderOrganizationInfo(res?.organizationData));
        else {
          toast(res?.message, { type: "error" });
          navigate(-1);
        }
      })
      .catch(() => resetLoader());
  };

  const getAmniusAdmin = () => {
    setAdminLoading(true);
    getAllAmniusAdmin(token).then((res) => {
      setAdminLoading(false);
      if (res?.data?.status) {
        setAmniusAdmins(res?.data?.data);
      }
    });
  };

  const sendRequest = (conn_id) => {
    setLoader();
    requestConnection(conn_id, token)
      .then((response) => {
        resetLoader();
        if (response?.status) {
          toast(response?.message, { type: "success" });
          getOrganizationData(token, conn_id).then((res) => {
            dispatch(renderOrganizationInfo(res?.organizationData));
          });
        } else {
          toast(response?.message, { type: "error" });
        }
      })
      .catch(() => {
        resetLoader();
        showFailureToast();
      });
  };

  const refreshLocations = () => setRefreshFlag((prev) => !prev);

  //organisation left card
  const orgLeft = () => {
    const isConnected = general_info?.isConnected;

    return (
      <div className="org-wrapper">
        <div className="org-upper" style={{ justifyContent: "space-between" }}>
          <div className="org-head">
            {isOtherRole ? "Organization Details" : "Admin Settings"}
          </div>
          <div className="org-status-action-wrapper">
            {isOtherRole && !isAmniusOrgPage && (
              <div
                className={
                  isConnected === "connected"
                    ? "org-view_all"
                    : "org-not-connected"
                }
              >
                {isConnected === "connected" ? (
                  <div>
                    CONNECTED <VerifiedIcon />
                  </div>
                ) : (
                  <div>
                    NOT CONNECTED <HideSourceIcon />
                  </div>
                )}
              </div>
            )}
            {isConnected === "pending" && (
              <Tooltip title="Request Pending" placement="top" arrow>
                <Button
                  variant="contained"
                  className={requestButtonClass}
                  style={{
                    background: "#C4A21C",
                    border: "solid 2px #C4A21C",
                    height: "100%",
                  }}
                >
                  <img
                    style={REQUEST_ICON_STYLE}
                    src={RequestPendingIcon}
                    alt="Request Pending Icon"
                  />
                </Button>
              </Tooltip>
            )}
            {isConnected === "not-connected" &&
              !isAmniusOrgPage &&
              loggedInUser?.scope !== "internal" && (
                <Tooltip title="Send Request" placement="top" arrow>
                  <Button
                    variant="contained"
                    className={requestButtonClass}
                    style={{
                      background: "rgb(92, 161, 39)",
                      border: "solid 2px rgb(92, 161, 39)",
                      height: "100%",
                    }}
                    onClick={() => sendRequest(general_info?.org_id)}
                  >
                    <img
                      style={REQUEST_ICON_STYLE}
                      src={SendRequestIcon}
                      alt="Send Request Icon"
                    />
                  </Button>
                </Tooltip>
              )}
          </div>
        </div>
        <div className="org-lower">
          <div className="org-admin-details">
            <div className="org-logo">
              <img
                src={general_info.logo || profilePic}
                alt="profile"
                width="120px"
                height="120px"
                onError={(e) => {
                  e.target.onerror = null; // Prevent infinite loop
                  e.target.src = profilePic; // Fallback to demo image
                }}
              />
            </div>
            <div className="org-bio">
              <div className="org-text">
                <h3>{general_info.organization_name || "Organization Name"}</h3>
                <div className="org-url">
                  <LanguageIcon />
                  <span>
                    Website:
                    <a
                      href={general_info.organization_website || undefined}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {general_info.organization_website || null}
                    </a>
                  </span>
                  <IosShareIcon />
                </div>
                {general_info?.address?.replaceAll(", ", "")?.length > 0 ? (
                  <p>
                    {general_info?.street}
                    {general_info?.city && `, ${general_info?.city}`}
                    {general_info?.state && `, ${general_info?.state}`}
                    {general_info?.country && `, ${general_info?.country}`}
                    {general_info?.zipcode && `, ${general_info?.zipcode}`}
                  </p>
                ) : (
                  "No address to Show"
                )}
              </div>
            </div>
          </div>
          <div className="org-admin-hover-wrapper">
            <Button
              variant="contained"
              className={requestButtonClass}
              style={GREEN_BUTTON_STYLE}
              onClick={() => {
                navigate({
                  pathname: `/portfolio/orgId/${general_info?.org_id}`,
                  search: "?type=portfolio",
                });
              }}
            >
              Portfolio
            </Button>
            {isOtherRole ? (
              <>
                {loggedInUser?.scope !== "internal" &&
                  general_info?.isServiceTicketSubscription && (
                    <Button
                      variant="contained"
                      className={requestButtonClass}
                      style={GREEN_BUTTON_STYLE}
                      onClick={() => {
                        if (loggedInUser?.ticket_external_role === "manager")
                          setRequestPopup(true);
                        else toast("You do not have access", { type: "info" });
                      }}
                    >
                      REQUEST SERVICE
                    </Button>
                  )}
                {isConnected === "connected" && (
                  <Button
                    variant="contained"
                    className={requestButtonClass}
                    style={{ background: "#5ca127" }}
                    onClick={() => {
                      navigate("/file-explorer");
                      dispatch(hashIdAction(general_info?.id));
                    }}
                  >
                    GO TO FOLDER
                  </Button>
                )}
              </>
            ) : (
              <Button
                variant="contained"
                className={requestButtonClass}
                style={GREEN_BUTTON_STYLE}
                onClick={() => {
                  if (
                    serviceTicketSubscription?.subscriptionStatus?.toString() ===
                    "true"
                  )
                    setInternalRequestPopup(true);
                  else
                    toast("You are not subscribed to service ticketing", {
                      type: "info",
                    });
                }}
              >
                REQUEST SERVICE
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  };

  // organisation right card
  const orgRight = () => (
    <div className="org-wrapper">
      <div className="org-upper">
        <div className="org-head">Admin And Team Details</div>
        <div className="org-request-butt"></div>
      </div>
      <div className="org-lower">
        {renderAdminDetails(adminLoading2)}
        {renderTeamDetails()}
      </div>
    </div>
  );

  // render admin details
  const renderAdminDetails = (adminLoading2) => (
    <div className="profile-details">
      <div className="profile-with-card">
        <div className="profile-tabs-wrapper">
          <div className="profile-banner">
            {showAmniusAdmins ? "SUPER ADMIN" : "ADMIN"}
          </div>

          {isOrgAmnius && isAmniusOrgPage
            ? ""
            : !isOtherRole && (
                <div
                  className="user-management-cta"
                  onClick={() => navigate("/service-ticket-user-management")}
                >
                  <img src={UserManagementIcon} alt="Service-Ticket" />
                  User Management
                </div>
              )}
        </div>
        <div className="profile-card-wrapper">
          {Object.keys(general_info).length?.toString() !== "0" ? (
            <RenderCard
              currEle={general_info}
              role={role}
              org_name={general_info?.organization_name}
              state={state}
              adminLoading2={adminLoading2}
            />
          ) : null}
        </div>
        {showAmniusAdmins && (
          <>
            <div
              className="profile-text-wrapper"
              style={{ marginTop: "10px" }}
            >
              <div className="profile-banner">ADMIN</div>
              <div className="profile-add">
                {role?.toString() === "super_admin" && (
                  <Button
                    variant="contained"
                    style={{ background: "#5ca127" }}
                    onClick={() => setOpenAddAmniusAdmin(true)}
                  >
                    +CREATE ADMIN
                  </Button>
                )}
              </div>
            </div>
            <div className="profile-card-wrapper">
              {!adminLoading ? (
                amniusAdmins.length > 0 ? (
                  amniusAdmins.map((item, index) => (
                    <RenderCard
                      key={item?.id ?? index}
                      state={state}
                      currEle={item}
                      role={item?.role}
                      org_name={general_info?.organization_name}
                      showEdit={isOrgAmnius ? "show" : "hide"}
                      isAdmin={true}
                      getAmniusAdmin={getAmniusAdmin}
                    />
                  ))
                ) : (
                  <p>No Admin Found</p>
                )
              ) : (
                <>
                  <div className="org-card-container">
                    <div className="org-card-board"></div>
                  </div>
                  <div className="org-card-container">
                    <div className="org-card-board"></div>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );

  //render team details
  const renderTeamDetails = () => (
    <div className="profile-details">
      <div className="profile-with-card">
        <TabContent
          role={role}
          setOpenAddUser={setOpenAddUser}
          general_info={general_info}
          state={state}
          refreshFlag={refreshFlag}
          refreshuser={refreshuser}
          refreshcategory={refreshcategory}
        />
      </div>
    </div>
  );

  return (
    <>
      <div className="org-container">
        <div className="org-header">
          <Headers />
        </div>

        <div className="org-navigation">
          <Navigation />
        </div>
        <div className="org-main">
          <div className="org-left">{orgLeft()}</div>
          <div className="org-right">{orgRight()}</div>
          <RenderAddUser
            popup={openAddUser}
            hide={setOpenAddUser}
            refreshLocations={refreshLocations}
            refreshTeams={() => setRefreshuser((prev) => !prev)}
            refreshcategory={() => setRefreshcategory((prev) => !prev)}
          />
        </div>
      </div>

      {requestPopup ? (
        <RenderSTRaiseRequestForm
          hide={setRequestPopup}
          service_org_id={general_info?.org_id}
        />
      ) : null}

      {internalRequestPopup ? (
        <RenderSTInternalRaiseRequestForm
          hide={setInternalRequestPopup}
          service_org_id={general_info?.org_id}
        />
      ) : null}
      <AddAmniusAdmin popup={openAddAmniusAdmin} hide={setOpenAddAmniusAdmin} />
      {loader}
    </>
  );
};

export default OrganisationUI;
